import { z } from "zod";

/**
 * Identités distinctes : les UUID sont identiques à l'exécution mais ne doivent
 * jamais être échangés entre le modèle applicatif et Supabase Auth.
 */
export const profileIdSchema = z.string().uuid().brand<"ProfileId">();
export type ProfileId = z.infer<typeof profileIdSchema>;

export const authUserIdSchema = z.string().uuid().brand<"AuthUserId">();
export type AuthUserId = z.infer<typeof authUserIdSchema>;

export type ChatReadMarker = `profile:${string}` | `portail:${string}`;

export function profileReadMarker(profileId: ProfileId): ChatReadMarker {
  return `profile:${profileId}`;
}

export function portailReadMarker(portailUserId: string): ChatReadMarker {
  return `portail:${portailUserId}`;
}

export function isChatReadMarker(value: unknown): value is ChatReadMarker {
  return typeof value === "string" && /^(profile|portail):[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
}